import request from '@/utils/request'
import Vue from 'vue'

/**
 * 根据模板名称获取模板
 * @param data
 * @returns {AxiosPromise}
 */
export function getAllocationTemplatePagers(data) {
  return request({
    url: '/smca/allocation-template/pagers',
    method: 'post',
    data: data
  })
}

export function getAllocationTemplateMatchTemplate(templateId) {
  return request({
    url: `/smca/allocation-template/match-template?templateId=${templateId}`,
    method: 'get'
  })
}

export function getTemplateDetail(templateId) {
  return request({
    url: `/smca/allocation-template?templateId=${templateId}`,
    method: 'get',
  })
}


export function getEmployee(filter) {
  return request({
    url: `/smca/flows-table/find/employees?filter=${filter}`,
    method: 'get',
  })
}

export function getAllocationTableHeaderDto(data) {
  return request({
    url: `/smca/data-fill/table-from`,
    method: 'post',
    data: data
  })
}

/**
 * 判断是否是已变更的流程
 * @param id
 * @returns {AxiosPromise}
 */
export function isProcessEffective(id) {
  return request({
    url: `/smca/flows-table/${id}/IsProcessEffective`,
    method: 'get'
  })
}

/**
 * 根据id查询信息 查询全部=> ""
 * @param id
 * @returns {AxiosPromise}
 */
export function getUnfinishedProcess(id = null) {
  return request({
    url: `/smca/flows-table/${id}/getUnfinishedProcess`,
    method: 'get'
  })
}

export function getEmployeeFill(id, time, data) {
  return request({
    url: `/smca/data-fill/${id}/employees?time=${time}`,
    method: 'post',
    data: data
  })
}

export function getFlowsTableDetail(id) {
  return request({
    url: `/smca/flows-control/${id}/flows-detail`,
    method: 'get'
  })
}

export function getBasicEmployeeApproval(flowsId, data) {
  return request({
    url: `/smca/flows-control/${flowsId}/basic-approval`,
    method: 'post',
    data: data
  })
}

export function getAvatar(empNo) {
  return request({
    url: `/smca/flows-table/${empNo}/avatar`,
    method: 'get'
  })
}

export function getEmployeeSubordinateInfo(id) {
  return request({
    url: `/smca/flows-table/${id}/understrapper`,
    method: 'get'
  })
}

// export function getEmp(code) {
//   return Vue.prototype.$http({
// 	url: Vue.prototype.$httpUrl.getuserinfo + "?code=" + code,
// 		method: "get",
// 	})
// }